class SelectInput extends HTMLElement {
  connectedCallback() {
    const select = this.querySelector("select");
    if (select.value) {
      select.closest(".text-input").classList.add("active");
    }
    select.addEventListener("change", (e) => {
      this.setActiveValue(e.target.value);
      select.closest(".text-input").classList.add("active");
    });
  }

  setActiveValue(val) {
    const options = Array.from(this.querySelectorAll("option"));
    const activeOption = options.find((o) => o.value === val);
    const target = this.querySelector(".select-target");

    if (activeOption) {
      target.innerHTML = activeOption.innerHTML;
    }
  }
}

customElements.define("select-input", SelectInput);
